import { getEnv } from "@/lib/utils/env";
import { Axiom } from "@axiomhq/js";

class MockAxiom implements Partial<Axiom> {
	async ingest() {}
	async flush() {}
	localPath = "";
	queryWithResult = async () => ({});
	queryLegacyWithResult = async () => ({});
}

/**
 * Silent error handler for Axiom client.
 * Suppresses JSON parse errors that occur when Axiom API returns empty responses.
 * These are transient and expected - they don't affect logging functionality.
 */
const silentOnError = (error: unknown) => {
	// Only log in development for debugging purposes
	if (process.env.NODE_ENV !== "production") {
		// Check if it's a JSON parse error (expected from empty Axiom responses)
		if (error instanceof SyntaxError && error.message.includes("JSON")) {
			// eslint-disable-next-line no-console
			console.debug("Axiom JSON parse error (expected, suppressed):", error.message);
			return;
		}
		// Log other errors in development
		// eslint-disable-next-line no-console
		console.warn("Axiom error (suppressed):", error);
	}
	// In production, silently ignore all Axiom errors to prevent Lambda log noise
};

/**
 * Axiom client for browser-side logging
 * Only initialized if NEXT_PUBLIC_AXIOM_TOKEN is available
 * Uses a silent error handler to prevent log noise from transient Axiom API issues
 */
const axiomToken = getEnv("NEXT_PUBLIC_AXIOM_TOKEN");
const axiomClient = axiomToken
	? new Axiom({ token: axiomToken, onError: silentOnError })
	: (new MockAxiom() as unknown as Axiom);

export default axiomClient;
